/*
 * @description: 公共常量
 * @author: SymbolQu
 * @createTime: 2025-07-17 17:46:50
 */

export const REFERRER_REQUEST = [
    '/api/qualify/v3/corporation/livingBody/authorizedPerson/submit',
    '/api/qualify/v3/person/bank/card/submit',
    '/api/qualify/v3/corporation/payment/create',
    '/api/qualify/v3/corporation/transfer/submit',
    '/api/qualify/v3/corporation/livingBody/legalPerson/submit',
    '/api/qualify/v3/person/certificate/submit',
    '/api/qualify/v3/person/livingBody/submit',
    '/api/qualify/syncpass',
];
